export default __webpack_public_path__ + "media/images/banner/banner-2-3fe0cf0e4401eec8d14793688ab6b525.jpg";